import { strings } from '../strings'
import { constants } from '../constants'
import '../styling/admin.css'
import { useState } from "react"
import BookingSummaryListItem from './BookingSummaryListItem'
import ExcelExport from './ExcelExport'

const BookingSummary = ({ users, bookings, type }) => {

    const userMap = new Map(users.map(user => [user._id, { ...user, balconyBookings: [], laundryBookings: [] }]))
    let totalLaundryBookings = 0
    let totalBalconyBookings = 0

    bookings.forEach(booking => {
        if (userMap.has(booking.user_id)) {
            if (booking.machineID === 3) {
                totalLaundryBookings += 2
                userMap.get(booking.user_id).laundryBookings.push(booking)
                userMap.get(booking.user_id).laundryBookings.push(booking)
            } else if (booking.machineID === 1 || booking.machineID === 2) {
                totalLaundryBookings += 1
                userMap.get(booking.user_id).laundryBookings.push(booking)
            }
            else {
                totalBalconyBookings += 1
                userMap.get(booking.user_id).balconyBookings.push(booking)
            }
        }
    })

    const mergedData = Array.from(userMap.values())
    let excelBalconyData = []
    let excelLaundryData = []

    bookings.filter((booking) => { return booking.duration === 1.5 }).forEach(booking => {
        excelLaundryData.push({
            användare: userMap.get(booking.user_id).userID,
            tid: new Date(booking.start).toLocaleDateString("sv-SE") + " " + new Date(booking.start).toLocaleTimeString("sv-SE"),
            tvättstuga: booking.facilityID.toString(),
            tvättmaskin: booking.machineID === 3 ? "1, 2" : booking.machineID.toString(),
            totalt: userMap.get(booking.user_id).laundryBookings.length
        })
    })

    bookings.filter((booking) => { return booking.duration === 6 }).forEach(booking => {
        excelBalconyData.push({
            användare: userMap.get(booking.user_id).userID,
            tid: new Date(booking.start).toLocaleDateString("sv-SE") + " " + new Date(booking.start).toLocaleTimeString("sv-SE"),
            totalt: userMap.get(booking.user_id).balconyBookings.length
        })
    })

    const currentYear = new Date()

    const [listFilter, setFilter] = useState({
        query: '',
        list: mergedData
    })

    const updateList = (e) => {

        let nameResults = []

        if (mergedData) {
            nameResults = mergedData.filter(user => {
                if (e.target.value === "") return mergedData
                return user.userID.toLowerCase().includes(e.target.value.toLowerCase())
            })
        }

        setFilter({
            query: e.target.value,
            list: nameResults
        })
    }

    return (
        <div className="booking-summary">
            <h1 className='booking-summary-title'>{type === constants.balconyType ? strings.admin.balconyTabTitle : strings.admin.laundryTabTitle} {currentYear.getFullYear()}</h1>
            <h2 className='booking-summary-total'>{strings.admin.total} {type === constants.balconyType ? totalBalconyBookings : totalLaundryBookings}</h2>
            <input className="search-user-input" type="search" value={listFilter.query} onChange={updateList} placeholder={strings.admin.search} />

            <div className='booking-summary-user-list'>
                {listFilter && listFilter.list.map((user) =>
                    <BookingSummaryListItem key={user._id} className='booking-summary-user-list-item' user={user} type={type} />
                )}
            </div>

            <ExcelExport data={type === constants.balconyType ? excelBalconyData : excelLaundryData} fileName={type + "-" + new Date().toLocaleDateString("sv-SE") + "-" + new Date().toLocaleTimeString("sv-SE")} />
        </div>
    )
}

export default BookingSummary